import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardChannel } from '../../models/dashboard.model';

// Filtro de canal logo abaixo do cartão de abertura: "Todos os canais" + um botão por canal
// (integração) da empresa. Com menos de 2 canais não há o que filtrar e nada é renderizado.
@Component({
  selector: 'app-dashboard-channel-filter',
  standalone: true,
  templateUrl: './dashboard-channel-filter.component.html',
  styleUrl: './dashboard-channel-filter.component.scss',
})
export class DashboardChannelFilterComponent {
  // Opcional: a API antiga não envia `channels`.
  @Input() channels?: DashboardChannel[] | null;
  /** integrationId escolhido; null = "Todos os canais". */
  @Input() value: number | null = null;
  @Output() valueChange = new EventEmitter<number | null>();

  get visible(): boolean {
    return (this.channels?.length ?? 0) >= 2;
  }

  select(id: number | null): void {
    if (id !== this.value) this.valueChange.emit(id);
  }
}
